<script lang="typescript">
    export let text: string = "Body 2/Roboto/Regular/14px";
    export let color = "var(--color-level-7)";
</script>

<h1 style="color: {color};" class="button-typography">{text}</h1>

<style>
    .button-typography {
        /* Button */
        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        /* identical to box height, or 114% */
        letter-spacing: 1.25px;
        text-transform: uppercase;

        pointer-events: none;
    }
</style>
